import { z } from 'zod';

export const taskCatalogDtoSchema = z.object({
  code: z.string().min(1).max(128),
  phaseCode: z.string().min(1).max(64),
  order: z.number().int().nonnegative(),
  mandatory: z.boolean(),
  label: z.string(),
  info: z.string(),
  path: z.string(),
});

export const phaseCatalogDtoSchema = z.object({
  code: z.string().min(1).max(64),
  order: z.number().int().nonnegative(),
  label: z.string(),
  description: z.string().optional(),
  unlocks: z.array(z.string()),
  tasks: z.array(taskCatalogDtoSchema),
});

export const phaseCatalogResponseSchema = z.object({
  phases: z.array(phaseCatalogDtoSchema),
});

export type TaskCatalogDto = z.infer<typeof taskCatalogDtoSchema>;
export type PhaseCatalogDto = z.infer<typeof phaseCatalogDtoSchema>;
export type PhaseCatalogResponse = z.infer<typeof phaseCatalogResponseSchema>;
